import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AiChatPanelContext } from './ai-chat-panel-context'
import { Button } from '@/shared/ui/button'
import { cn } from '@/shared/lib/utils'

export function AiChatAvatarButton() {
  const panel = useContext(AiChatPanelContext)
  const { t } = useTranslation('aiChat')
  if (!panel) return null

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn(
        'size-10 rounded-full',
        panel.open && 'bg-primary/10 ring-2 ring-primary/40',
      )}
      aria-label={t('toggleChat')}
      aria-expanded={panel.open}
      title={t('workspaceTitle')}
      onClick={panel.toggleChat}
    >
      <img
        src="/logo.png"
        alt=""
        className="size-8 rounded-full bg-muted object-contain"
      />
    </Button>
  )
}
